import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

// https://github.com/foxbroadcasting/apigateway/blob/master/v2.0/services/discountverification.yaml
export const addSheerVerificationId = async (verificationID) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('add sheer verification Id', verificationID);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/verification`,
      method: 'POST',
      data: { verificationID },
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('add sheer verification Id success', data);
    return data;
  } catch (error) {
    console.error(error.message);
    logger.apiError('add sheer verification Id error', null, error.message);
    return { error: error.message };
  }
};

export const getOrganizations = async (programName = 'MILITARY' /* MILITARY, FIRST_RESPONDER */, query = null) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('get sheer organizations', programName);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/program/${programName}${query ? `?name=${query}` : ''}`,
      method: 'GET',
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('get sheer organizations', data);
    return data;
  } catch (error) {
    console.error(error.message);
    logger.apiError('get sheer organizations', null, error.message);
    return { error: error.message };
  }
};

export const submitActiveMilitaryInfo = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit active military info', payload);
  try {
    const result = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/collectActiveMilitaryPersonalInfo`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit active military info', result?.data);
    return result?.data || result?.response?.data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit active military info', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('submit active military info', null, error);
    return Promise.reject(error);
  }
};

export const submitInactiveMilitaryInfo = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit inactive military info', payload);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/collectInactiveMilitaryPersonalInfo`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit inactive military info', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit inactive military info', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('submit inactive military info', null, error);
    return Promise.reject(error);
  }
};

export const submitFirstResponderPersonalInfo = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit first responder personal info', payload);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/collectFirstResponderPersonalInfo`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit first responder personal info', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit first responder personal info', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('submit first responder personal info', null, error);
    return Promise.reject(error);
  }
};

export const associateBangoSubscription = async (subscriptionRequestId, redirectUrl) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('associate bango subscription', { subscriptionRequestId, redirectUrl });
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/bango/associateSubscription`,
      method: 'PATCH',
      data: {
        subscriptionRequestId,
        redirectUrl,
      },
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('associate bango subscription', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('associate bango subscription', error.response.data.errorMessage, error);
      return Promise.reject(error.response.data.errorMessage);
    }
    logger.apiError('associate bango subscription', null, error);
    return Promise.reject(error);
  }
};

export const getMemberVerify = async () => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('get member verify', {});
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/user`,
      method: 'GET',
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('get member verify', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('get member verify', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('get member verify', null, error);
    return Promise.reject(error);
  }
};

export const cancelVerification = async () => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('cancel verification', {});
  try {
    const result = await RequestService.send({
      url: `${foxApi}/memberverify/verification/cancel`,
      method: 'DELETE',
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('cancel verification', result);
    return result;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('cancel verification', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('cancel verification', null, error);
    return Promise.reject(error);
  }
};
